import styled, { css } from 'styled-components';

export const BrandListContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
`;

export const BrandList = styled.ul<{ isCompact?: boolean }>`
  display: grid;
  grid-template-columns: ${({ isCompact }) => (isCompact ? 'repeat(4, 1fr)' : 'repeat(auto-fill, minmax(200px, 1fr))')};
  gap: ${({ isCompact }) => (isCompact ? '0.5rem' : '1.5rem')};
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;

  ${({ isCompact }) =>
    !isCompact &&
    css`
      @media screen and (max-width: 768px) {
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
      }

      @media screen and (max-width: 540px) {
        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
      }
    `}
`;

export const BrandListItem = styled.li`
  aspect-ratio: 1 / 1;
  border-radius: 1rem;
  corner-shape: squircle;
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.25);
  background: #fff;
  overflow: hidden;
  display: flex;
`;
